import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

import {
    useGetUserByIdQuery,
    useUpdateUserByIdMutation,
} from '@/features/slice/users';
import { TCreateUserForm } from '@/modules/users/create-user/create-user.schema';
import { toastError } from '@/utils';

export const useEditUser = () => {
    const params = useParams();

    const userId = params['id'] || '';

    const { data, isLoading, isError, isFetching, error } =
        useGetUserByIdQuery(userId);

    const [updateUser, { isLoading: isUpdating }] = useUpdateUserByIdMutation();

    const handleSubmit = async (data: TCreateUserForm) => {
        try {
            await updateUser({ userId, data }).unwrap();
            toast.success('User updated successfully.');
        } catch (error) {
            toastError(
                error,
                'useEditUser -> handleSubmit: Failed to update user.',
            );
        }
    };

    return {
        userId,
        handleSubmit,

        data,
        isLoading,
        isError,
        isFetching,
        error,
        isUpdating,
    };
};
